import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";
import { CLUSTERS } from "@/lib/clusterMeta";

export const Route = createFileRoute("/_app/rates/")({
  head: () =>
    buildHead({
      title: "Live Scrap, Steel & Plastic Rates in India | LohaLink",
      description:
        "Live wholesale rates for HMS scrap, TMT bar, billets, sponge iron, dolomite and PET/HDPE plastic scrap across Jamshedpur, Durgapur, Raipur and Mumbai. Updated daily.",
      canonical: "/rates",
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Live Scrap Metal Rates Across India",
          url: "https://lohalink.in/rates",
          description:
            "Daily benchmarked scrap and steel rates across India's top trading clusters.",
          hasPart: CLUSTERS.map((c) => ({
            "@type": "WebPage",
            name: `Scrap metal rates in ${c.name}`,
            url: `https://lohalink.in/rates/${c.slug}`,
          })),
        },
      ],
    }),
  component: lazyRouteComponent(() => import("@/pages/Rates")),
});
